(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    // Per-line debounce timers. Multiple rapid clicks/typing accumulate
    // into one /cart/change.js request using the latest visible quantity.
    const DEBOUNCE_MS = 350;
    const timers = {};
    let inFlight = false;
    let pendingLine = null;

    function getSection() {
      return document.querySelector('.cart-section');
    }

    function getSectionId() {
      const section = getSection();
      return section ? section.getAttribute('data-section-id') : null;
    }

    function getInput(line) {
      const section = getSection();
      if (!section) return null;
      return section.querySelector('.cart-section__quantity-input[data-line="' + line + '"]');
    }

    function updateHeaderCount(itemCount) {
      const cartIcon = document.querySelector('.header__cart');
      if (!cartIcon) return;
      let countEl = cartIcon.querySelector('.header__cart-count');
      if (itemCount > 0) {
        if (!countEl) {
          countEl = document.createElement('span');
          countEl.className = 'header__cart-count';
          cartIcon.appendChild(countEl);
        }
        countEl.textContent = itemCount;
      } else if (countEl) {
        countEl.remove();
      }
    }

    function swapSection(sectionHtml) {
      const sectionId = getSectionId();
      if (!sectionId) return;
      const wrapper = document.getElementById('shopify-section-' + sectionId);
      if (!wrapper) return;

      // Parse the returned HTML and find the inner section wrapper to
      // pull out only the contents (Section Rendering API returns the
      // section's rendered output including the shopify-section wrapper).
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHtml, 'text/html');
      const newWrapper = doc.getElementById('shopify-section-' + sectionId);
      wrapper.innerHTML = newWrapper ? newWrapper.innerHTML : sectionHtml;
    }

    function flush(line) {
      if (inFlight) {
        // Queue the latest line — when the current request completes we'll
        // re-trigger the debounce so the latest state still gets sent.
        pendingLine = line;
        return;
      }
      const input = getInput(line);
      if (!input) return;
      let quantity = parseInt(input.value, 10);
      if (isNaN(quantity) || quantity < 0) quantity = 0;

      const sectionId = getSectionId();

      inFlight = true;
      const section = getSection();
      if (section) section.classList.add('cart-section--updating');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity,
          sections: sectionId
        })
      })
        .then(function(response) {
          if (!response.ok) throw new Error('Cart change failed: ' + response.status);
          return response.json();
        })
        .then(function(data) {
          if (data && data.sections && sectionId && data.sections[sectionId]) {
            swapSection(data.sections[sectionId]);
          }
          if (typeof data.item_count === 'number') {
            updateHeaderCount(data.item_count);
          }
        })
        .catch(function(error) {
          console.error('Cart update error:', error);
        })
        .then(function() {
          inFlight = false;
          // Clear the loading state on the current section (after a
          // successful swap, the freshly-rendered section won't have the
          // class anyway; on error, this clears it from the original).
          const currentSection = getSection();
          if (currentSection) currentSection.classList.remove('cart-section--updating');
          // If another change happened while in flight, send it now.
          if (pendingLine !== null) {
            const next = pendingLine;
            pendingLine = null;
            flush(next);
          }
        });
    }

    function scheduleUpdate(line) {
      clearTimeout(timers[line]);
      timers[line] = setTimeout(function() { flush(line); }, DEBOUNCE_MS);
    }

    // Event delegation on document so listeners survive section swaps.
    document.addEventListener('click', function(e) {
      const section = e.target.closest('.cart-section');
      if (!section) return;

      const quantityChange = e.target.closest('[data-quantity-change]');
      const removeBtn = e.target.closest('[data-remove-line]');

      if (quantityChange) {
        e.preventDefault();
        const line = parseInt(quantityChange.dataset.line, 10);
        const input = getInput(line);
        if (!input) return;
        const change = parseInt(quantityChange.dataset.quantityChange, 10);
        let newValue = (parseInt(input.value, 10) || 0) + change;
        if (newValue < 0) newValue = 0;
        input.value = newValue;
        scheduleUpdate(line);
      }

      if (removeBtn) {
        e.preventDefault();
        const line = parseInt(removeBtn.dataset.removeLine, 10);
        const input = getInput(line);
        if (input) input.value = 0;
        clearTimeout(timers[line]);
        flush(line);
      }
    });

    document.addEventListener('change', function(e) {
      if (!e.target.matches('.cart-section__quantity-input')) return;
      const input = e.target;
      const line = parseInt(input.dataset.line, 10);
      let value = parseInt(input.value, 10);
      if (isNaN(value) || value < 0) value = 0;
      input.value = value;
      scheduleUpdate(line);
    });

    document.addEventListener('input', function(e) {
      if (!e.target.matches('.cart-section__quantity-input')) return;
      const line = parseInt(e.target.dataset.line, 10);
      scheduleUpdate(line);
    });

    document.addEventListener('keydown', function(e) {
      if (!e.target.matches('.cart-section__quantity-input')) return;
      if (e.key === 'Enter') {
        e.preventDefault();
        e.target.blur();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    const section = document.querySelector('.collection-section');
    if (!section) return;

    const sortSelect = section.querySelector('[data-sort-select]');
    const viewBtns = section.querySelectorAll('[data-view]');
    const grid = section.querySelector('[data-product-grid]');

    // Sort change
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    }

    // View toggle
    viewBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        viewBtns.forEach(function(b) { b.classList.remove('active'); });
        this.classList.add('active');
        const view = this.dataset.view;
        if (view === 'list') {
          grid.classList.add('list-view');
        } else {
          grid.classList.remove('list-view');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fullwidth-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const banners = document.querySelectorAll('.fullwidth-banner');

    banners.forEach(function(banner) {
      const slidesContainer = banner.querySelector('[data-slides]');
      const slides = slidesContainer.querySelectorAll('.fullwidth-banner__slide');
      const dotsContainer = banner.querySelector('[data-dots]');
      const dots = dotsContainer ? dotsContainer.querySelectorAll('.fullwidth-banner__dot') : [];

      if (slides.length <= 1) return;

      let currentIndex = 0;
      let autoplayInterval = null;
      const autoplay = banner.dataset.autoplay === 'true';
      const autoplaySpeed = (parseInt(banner.dataset.autoplaySpeed) || 5) * 1000;

      function goToSlide(index) {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;

        slides[currentIndex].classList.remove('active');
        if (dots[currentIndex]) dots[currentIndex].classList.remove('active');

        currentIndex = index;

        slides[currentIndex].classList.add('active');
        if (dots[currentIndex]) dots[currentIndex].classList.add('active');
      }

      function nextSlide() {
        goToSlide(currentIndex + 1);
      }

      function startAutoplay() {
        if (autoplay && !autoplayInterval) {
          autoplayInterval = setInterval(nextSlide, autoplaySpeed);
        }
      }

      function stopAutoplay() {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      }

      // Dot click events
      dots.forEach(function(dot, index) {
        dot.addEventListener('click', function() {
          goToSlide(index);
          stopAutoplay();
          startAutoplay();
        });
      });

      // Pause on hover
      banner.addEventListener('mouseenter', stopAutoplay);
      banner.addEventListener('mouseleave', startAutoplay);

      // Start autoplay
      startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('.header');
    const toggle = header.querySelector('.header__toggle');
    const drawer = header.querySelector('.header__mobile-drawer');
    const dropdownToggles = header.querySelectorAll('.header__mobile-dropdown-toggle');

    // Mobile menu toggle
    if (toggle && drawer) {
      toggle.addEventListener('click', function () {
        const expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !expanded);
        drawer.classList.toggle('active');
        document.body.style.overflow = expanded ? '' : 'hidden';
      });
    }

    // Dropdown toggles for mobile
    dropdownToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        const menuItem = this.closest('.header__mobile-menu-item');
        const expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !expanded);
        menuItem.classList.toggle('active');
      });
    });

    // Search modal functionality
    const searchToggle = header.querySelector('.header__search-toggle');
    const searchModal = document.getElementById('search-modal');
    const searchClose = searchModal ? searchModal.querySelector('.search-modal__close') : null;
    const searchOverlay = searchModal ? searchModal.querySelector('.search-modal__overlay') : null;
    const searchInput = searchModal ? searchModal.querySelector('.search-modal__input') : null;

    function openSearchModal() {
      if (searchModal) {
        searchModal.classList.add('active');
        searchModal.setAttribute('aria-hidden', 'false');
        searchToggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        if (searchInput) {
          setTimeout(function () {
            searchInput.focus();
          }, 100);
        }
      }
    }

    function closeSearchModal() {
      if (searchModal) {
        searchModal.classList.remove('active');
        searchModal.setAttribute('aria-hidden', 'true');
        searchToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        if (searchInput) {
          searchInput.value = '';
        }
      }
    }

    if (searchToggle) {
      searchToggle.addEventListener('click', openSearchModal);
    }

    if (searchClose) {
      searchClose.addEventListener('click', closeSearchModal);
    }

    if (searchOverlay) {
      searchOverlay.addEventListener('click', closeSearchModal);
    }

    // Close modal on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchModal && searchModal.classList.contains('active')) {
        closeSearchModal();
      }
    });
  })();

  // Localization Selector Enhancement
  (function () {
    const selectors = document.querySelectorAll('[data-localization-selector]');

    if (!selectors.length) return;

    selectors.forEach(function (selectorWrapper) {
      const toggle = selectorWrapper.querySelector('[data-selector-toggle]');
      const dropdown = selectorWrapper.querySelector('[data-selector-dropdown]');
      const searchInput = selectorWrapper.querySelector('[data-selector-search]');
      const optionsList = selectorWrapper.querySelector('[data-selector-list]');
      const options = Array.from(selectorWrapper.querySelectorAll('[data-selector-option]'));
      const noResults = selectorWrapper.querySelector('[data-selector-no-results]');
      const countBadge = selectorWrapper.querySelector('[data-selector-count]');
      const totalCount = options.length;

      let isOpen = false;
      let focusedIndex = -1;

      // Toggle dropdown
      function toggleDropdown(open) {
        isOpen = typeof open === 'boolean' ? open : !isOpen;

        toggle.setAttribute('aria-expanded', isOpen);
        dropdown.classList.toggle('active', isOpen);

        if (isOpen) {
          if (searchInput) {
            setTimeout(function () {
              searchInput.focus();
            }, 100);
          }
          focusedIndex = -1;
        } else {
          if (searchInput) {
            searchInput.value = '';
            filterOptions('');
          }
          toggle.focus();
        }
      }

      // Filter options based on search
      function filterOptions(query) {
        const normalizedQuery = query.toLowerCase().trim();
        let visibleCount = 0;

        options.forEach(function (option) {
          const searchText = option.getAttribute('data-search-text') || '';
          const matches = !normalizedQuery || searchText.includes(normalizedQuery);

          if (matches) {
            option.parentElement.removeAttribute('hidden');
            option.removeAttribute('hidden');
            visibleCount++;
          } else {
            option.parentElement.setAttribute('hidden', '');
            option.setAttribute('hidden', '');
          }
        });

        // Update count badge
        if (countBadge) {
          countBadge.textContent = visibleCount;
        }

        // Show/hide no results message
        if (noResults) {
          if (visibleCount === 0) {
            noResults.removeAttribute('hidden');
            optionsList.setAttribute('hidden', '');
          } else {
            noResults.setAttribute('hidden', '');
            optionsList.removeAttribute('hidden');
          }
        }

        focusedIndex = -1;
      }

      // Keyboard navigation
      function getVisibleOptions() {
        return options.filter(function (opt) {
          return !opt.hasAttribute('hidden');
        });
      }

      function focusOption(index) {
        const visibleOptions = getVisibleOptions();
        if (visibleOptions.length === 0) return;

        // Wrap around
        if (index < 0) {
          index = visibleOptions.length - 1;
        } else if (index >= visibleOptions.length) {
          index = 0;
        }

        focusedIndex = index;
        visibleOptions[index].focus();
      }

      function handleKeyDown(e) {
        if (!isOpen) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleDropdown(true);
          }
          return;
        }

        switch (e.key) {
          case 'Escape':
            e.preventDefault();
            toggleDropdown(false);
            break;
          case 'ArrowDown':
            e.preventDefault();
            focusOption(focusedIndex + 1);
            break;
          case 'ArrowUp':
            e.preventDefault();
            focusOption(focusedIndex - 1);
            break;
          case 'Home':
            e.preventDefault();
            focusOption(0);
            break;
          case 'End':
            e.preventDefault();
            focusOption(getVisibleOptions().length - 1);
            break;
          case 'Tab':
            toggleDropdown(false);
            break;
          case '/':
            // Focus search on "/" key (only if not already in search)
            if (searchInput && document.activeElement !== searchInput) {
              e.preventDefault();
              searchInput.focus();
            }
            break;
        }
      }

      // Event listeners
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleDropdown();
      });

      toggle.addEventListener('keydown', handleKeyDown);

      if (searchInput) {
        searchInput.addEventListener('input', function (e) {
          filterOptions(e.target.value);
        });

        searchInput.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            focusOption(0);
          } else if (e.key === 'Escape') {
            e.preventDefault();
            toggleDropdown(false);
          }
        });
      }

      // Option keyboard handling
      options.forEach(function (option, index) {
        option.addEventListener('keydown', function (e) {
          handleKeyDown(e);

          // Update focusedIndex when option receives focus
          const visibleOptions = getVisibleOptions();
          focusedIndex = visibleOptions.indexOf(option);
        });
      });

      // Close on outside click
      document.addEventListener('click', function (e) {
        if (isOpen && !selectorWrapper.contains(e.target)) {
          toggleDropdown(false);
        }
      });

      // Close on Escape (global)
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen) {
          toggleDropdown(false);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Global registry to track active slideshows and their cleanup functions
    var activeSlideshows = {};

    function init(slideshow) {
      const slidesContainer = slideshow.querySelector('[data-slides]');
      const track = slideshow.querySelector('[data-track]');
      if (!track) return;

      const slides = track.querySelectorAll('.hero-slideshow__slide');
      const dots = slideshow.querySelectorAll('.hero-slideshow__dot');
      const prevBtn = slideshow.querySelector('[data-prev]');
      const nextBtn = slideshow.querySelector('[data-next]');

      if (slides.length <= 1) return;

      // Get section ID for cleanup tracking
      var sectionId = slideshow.id ? slideshow.id.replace('shopify-section-', '') : null;

      // Clean up existing instance if it exists
      if (sectionId && activeSlideshows[sectionId]) {
        activeSlideshows[sectionId]();
        delete activeSlideshows[sectionId];
      }

      let currentIndex = 0;
      let autoplayInterval = null;
      const autoplay = slideshow.dataset.autoplay === 'true';
      const autoplaySpeed = (parseInt(slideshow.dataset.autoplaySpeed, 10) || 5) * 1000;
      const isDesignMode = typeof Shopify !== 'undefined' && Shopify.designMode;

      function goToSlide(index) {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;

        currentIndex = index;

        track.style.transform = 'translateX(-' + currentIndex * 100 + '%)';

        dots.forEach(function (dot, i) {
          dot.classList.toggle('active', i === currentIndex);
        });
      }

      function nextSlide() {
        goToSlide(currentIndex + 1);
      }

      function prevSlide() {
        goToSlide(currentIndex - 1);
      }

      function startAutoplay() {
        if (isDesignMode) return;
        if (autoplay && !autoplayInterval) {
          autoplayInterval = setInterval(nextSlide, autoplaySpeed);
        }
      }

      function stopAutoplay() {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      }

      if (prevBtn)
        prevBtn.addEventListener('click', function () {
          prevSlide();
          stopAutoplay();
          startAutoplay();
        });

      if (nextBtn)
        nextBtn.addEventListener('click', function () {
          nextSlide();
          stopAutoplay();
          startAutoplay();
        });

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          goToSlide(index);
          stopAutoplay();
          startAutoplay();
        });
      });

      slideshow.addEventListener('mouseenter', stopAutoplay);
      slideshow.addEventListener('mouseleave', startAutoplay);

      const DRAG_THRESHOLD = 50;
      const TOUCH_MOUSE_DEDUPE_MS = 400;
      let touchStartX = 0;
      let touchEndX = 0;
      let mouseStartX = 0;
      let mouseEndX = 0;
      let isMouseDragging = false;
      let lastTouchEndTime = 0;

      function handleSwipe() {
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > DRAG_THRESHOLD) {
          if (diff > 0) {
            nextSlide();
          } else {
            prevSlide();
          }
          stopAutoplay();
          startAutoplay();
        }
      }

      slidesContainer.addEventListener(
        'touchstart',
        function (e) {
          touchStartX = e.changedTouches[0].screenX;
        },
        { passive: true }
      );
      slidesContainer.addEventListener(
        'touchend',
        function (e) {
          touchEndX = e.changedTouches[0].screenX;
          handleSwipe();
          lastTouchEndTime = Date.now();
        },
        { passive: true }
      );

      slidesContainer.addEventListener('mousedown', function (e) {
        if (Date.now() - lastTouchEndTime < TOUCH_MOUSE_DEDUPE_MS) return;
        isMouseDragging = true;
        mouseStartX = e.clientX;
        mouseEndX = e.clientX;
        slidesContainer.classList.add('hero-slideshow__slides--dragging');
      });

      function mouseMoveHandler(e) {
        if (isMouseDragging) mouseEndX = e.clientX;
      }
      function mouseUpHandler() {
        if (!isMouseDragging) return;
        slidesContainer.classList.remove('hero-slideshow__slides--dragging');
        isMouseDragging = false;
        const diff = mouseStartX - mouseEndX;
        if (Math.abs(diff) > DRAG_THRESHOLD) {
          if (diff > 0) {
            nextSlide();
          } else {
            prevSlide();
          }
          stopAutoplay();
          startAutoplay();
        }
      }
      function mouseLeaveHandler() {
        if (isMouseDragging) {
          slidesContainer.classList.remove('hero-slideshow__slides--dragging');
          isMouseDragging = false;
        }
      }
      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
      document.addEventListener('mouseleave', mouseLeaveHandler);

      function blockSelectHandler(e) {
        if (!slideshow.contains(e.target)) return;
        if (!e.target.classList.contains('hero-slideshow__slide')) return;
        var idx = Array.prototype.indexOf.call(slides, e.target);
        if (idx >= 0) {
          goToSlide(idx);
          if (isDesignMode) stopAutoplay();
        }
      }
      document.addEventListener('shopify:block:select', blockSelectHandler);

      // Create cleanup function
      function cleanup() {
        stopAutoplay();
        document.removeEventListener('shopify:block:select', blockSelectHandler);
        document.removeEventListener('shopify:section:unload', unloadHandler);
        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
        document.removeEventListener('mouseleave', mouseLeaveHandler);
      }

      function unloadHandler(e) {
        if (sectionId && e.detail && e.detail.sectionId === sectionId) {
          cleanup();
          if (sectionId && activeSlideshows[sectionId]) {
            delete activeSlideshows[sectionId];
          }
        }
      }
      document.addEventListener('shopify:section:unload', unloadHandler);

      // Store cleanup function in registry
      if (sectionId) {
        activeSlideshows[sectionId] = cleanup;
      }

      goToSlide(0);
      startAutoplay();
    }

    document.querySelectorAll('.hero-slideshow').forEach(init);

    document.addEventListener('shopify:section:load', function (e) {
      if (!e.detail || !e.detail.sectionId) return;
      var sectionWrapper = document.getElementById('shopify-section-' + e.detail.sectionId);
      if (sectionWrapper) {
        var slideshow = sectionWrapper.querySelector('.hero-slideshow');
        if (slideshow) {
          init(slideshow);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sliders = document.querySelectorAll('.product-slider');

    sliders.forEach(function (slider) {
      const track = slider.querySelector('[data-track]');
      const slides = track.querySelectorAll('.product-slider__slide');
      const prevBtn = slider.querySelector('[data-prev]');
      const nextBtn = slider.querySelector('[data-next]');
      const dotsContainer = slider.querySelector('[data-dots]');

      if (slides.length <= 1) return;

      let currentIndex = 0;
      let slidesPerView = getSlidesPerView();
      let totalPages = Math.ceil(slides.length / slidesPerView);
      let autoplayInterval = null;
      const autoplay = slider.dataset.autoplay === 'true';
      const autoplaySpeed = (parseInt(slider.dataset.autoplaySpeed) || 5) * 1000;

      // Create dots
      function createDots() {
        dotsContainer.innerHTML = '';
        totalPages = Math.ceil(slides.length / slidesPerView);
        for (let i = 0; i < totalPages; i++) {
          const dot = document.createElement('button');
          dot.className = 'product-slider__dot' + (i === 0 ? ' active' : '');
          dot.setAttribute('aria-label', 'Page ' + (i + 1));
          dot.addEventListener('click', function () {
            goToPage(i);
            stopAutoplay();
            startAutoplay();
          });
          dotsContainer.appendChild(dot);
        }
      }

      function getSlidesPerView() {
        if (window.innerWidth <= 480) return 1;
        if (window.innerWidth <= 768) return 2;
        if (window.innerWidth <= 991) return 3;
        return parseInt(getComputedStyle(slider).getPropertyValue('--products-per-row')) || 4;
      }

      function getSlideWidth() {
        return slides[0].offsetWidth + 20; // Include gap
      }

      function goToPage(pageIndex) {
        const maxIndex = slides.length - slidesPerView;
        currentIndex = Math.min(pageIndex * slidesPerView, maxIndex);
        currentIndex = Math.max(0, currentIndex);

        const offset = currentIndex * getSlideWidth();
        track.style.transform = 'translateX(-' + offset + 'px)';

        updateDots(pageIndex);
        updateArrows();
      }

      function updateDots(pageIndex) {
        const dots = dotsContainer.querySelectorAll('.product-slider__dot');
        dots.forEach(function (dot, index) {
          dot.classList.toggle('active', index === pageIndex);
        });
      }

      function updateArrows() {
        if (prevBtn) prevBtn.disabled = currentIndex === 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= slides.length - slidesPerView;
      }

      function nextPage() {
        const currentPage = Math.floor(currentIndex / slidesPerView);
        if (currentPage < totalPages - 1) {
          goToPage(currentPage + 1);
        } else {
          goToPage(0);
        }
      }

      function prevPage() {
        const currentPage = Math.floor(currentIndex / slidesPerView);
        if (currentPage > 0) {
          goToPage(currentPage - 1);
        } else {
          goToPage(totalPages - 1);
        }
      }

      function startAutoplay() {
        if (autoplay && !autoplayInterval) {
          autoplayInterval = setInterval(nextPage, autoplaySpeed);
        }
      }

      function stopAutoplay() {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      }

      // Event Listeners
      if (prevBtn)
        prevBtn.addEventListener('click', function () {
          prevPage();
          stopAutoplay();
          startAutoplay();
        });

      if (nextBtn)
        nextBtn.addEventListener('click', function () {
          nextPage();
          stopAutoplay();
          startAutoplay();
        });

      // Touch/drag support
      let isDragging = false;
      let startX = 0;
      let scrollLeft = 0;

      track.addEventListener('mousedown', function (e) {
        isDragging = true;
        startX = e.pageX;
        scrollLeft = currentIndex * getSlideWidth();
        stopAutoplay();
      });

      track.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX;
        const walk = startX - x;
        track.style.transform = 'translateX(-' + (scrollLeft + walk) + 'px)';
      });

      track.addEventListener('mouseup', function (e) {
        if (!isDragging) return;
        isDragging = false;
        const walk = startX - e.pageX;
        if (Math.abs(walk) > 50) {
          if (walk > 0) nextPage();
          else prevPage();
        } else {
          goToPage(Math.floor(currentIndex / slidesPerView));
        }
        startAutoplay();
      });

      track.addEventListener('mouseleave', function () {
        if (isDragging) {
          isDragging = false;
          goToPage(Math.floor(currentIndex / slidesPerView));
          startAutoplay();
        }
      });

      // Touch events
      track.addEventListener(
        'touchstart',
        function (e) {
          startX = e.touches[0].pageX;
          scrollLeft = currentIndex * getSlideWidth();
          stopAutoplay();
        },
        { passive: true }
      );

      track.addEventListener(
        'touchmove',
        function (e) {
          const x = e.touches[0].pageX;
          const walk = startX - x;
          track.style.transform = 'translateX(-' + (scrollLeft + walk) + 'px)';
        },
        { passive: true }
      );

      track.addEventListener(
        'touchend',
        function (e) {
          const walk = startX - e.changedTouches[0].pageX;
          if (Math.abs(walk) > 50) {
            if (walk > 0) nextPage();
            else prevPage();
          } else {
            goToPage(Math.floor(currentIndex / slidesPerView));
          }
          startAutoplay();
        },
        { passive: true }
      );

      // Resize handler
      let resizeTimeout;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
          slidesPerView = getSlidesPerView();
          createDots();
          goToPage(0);
        }, 200);
      });

      // Pause on hover
      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);

      // Initialize
      createDots();
      updateArrows();
      startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('[data-product-section]');
    if (!section) return;

    const productJsonEl = section.querySelector('[data-product-json]');
    let productData = null;
    try {
      productData = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
    } catch (e) {
      productData = null;
    }

    const stringsEl = section.querySelector('[data-product-strings]');
    let strings = { add_to_cart: 'Add to cart', sold_out: 'Sold out', unavailable: 'Unavailable', money_format: '$\x7B\x7Bamount\x7D\x7D' };
    try {
      if (stringsEl) {
        const parsed = JSON.parse(stringsEl.textContent);
        strings = Object.assign(strings, parsed);
      }
    } catch (e) { /* keep defaults */ }

    const mainImage = section.querySelector('#product-main-image');
    const thumbnails = section.querySelectorAll('[data-thumbnail]');
    const variantSelect = section.querySelector('[data-variant-select]');
    const optionInputs = section.querySelectorAll('[data-option-position]');
    const quantityInput = section.querySelector('[data-quantity-input]');
    const quantityWrapper = section.querySelector('[data-quantity-wrapper]');
    const minusBtn = section.querySelector('[data-quantity-minus]');
    const plusBtn = section.querySelector('[data-quantity-plus]');
    const addToCartBtn = section.querySelector('[data-add-to-cart]');
    const addToCartText = section.querySelector('[data-add-to-cart-text]');
    const priceEl = section.querySelector('[data-price]');
    const comparePriceEl = section.querySelector('[data-compare-price]');

    // Thumbnail click
    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbnails.forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
        if (mainImage) {
          mainImage.src = this.dataset.imageUrl;
          mainImage.removeAttribute('srcset');
        }
      });
    });

    function getSelectedOptions() {
      const selected = [];
      const grouped = {};
      optionInputs.forEach(function(input) {
        if (input.checked) {
          grouped[parseInt(input.dataset.optionPosition, 10)] = input.value;
        }
      });
      const positions = Object.keys(grouped).map(function(k) { return parseInt(k, 10); }).sort(function(a, b) { return a - b; });
      positions.forEach(function(p) { selected.push(grouped[p]); });
      return selected;
    }

    function findMatchingVariant(selectedOptions) {
      if (!productData || !productData.variants) return null;
      return productData.variants.find(function(v) {
        return selectedOptions.every(function(value, idx) {
          return v.options[idx] === value;
        });
      });
    }

    function updateOptionAvailability() {
      if (!productData || !productData.variants) return;
      const selectedOptions = getSelectedOptions();

      optionInputs.forEach(function(input) {
        const pos = parseInt(input.dataset.optionPosition, 10) - 1;
        const value = input.value;

        // A value at position `pos` is available if there exists a variant where:
        //  - variant.options[pos] === value
        //  - other selected positions match (excluding this position)
        //  - variant.available === true
        const available = productData.variants.some(function(v) {
          if (!v.available) return false;
          if (v.options[pos] !== value) return false;
          for (let i = 0; i < selectedOptions.length; i++) {
            if (i === pos) continue;
            if (v.options[i] !== selectedOptions[i]) return false;
          }
          return true;
        });

        const wrapper = input.closest('.product-section__option-value');
        if (wrapper) {
          wrapper.classList.toggle('product-section__option-value--unavailable', !available);
        }
      });
    }

    function updateVariantUI(variant) {
      // Update variant select
      if (variantSelect && variant) {
        variantSelect.value = variant.id;
      }

      // Update price
      if (priceEl && variant) {
        priceEl.textContent = formatMoney(variant.price);
        priceEl.classList.toggle('product-section__price--sale', variant.compare_at_price > variant.price);
      }
      if (comparePriceEl && variant) {
        if (variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      // Update featured image
      if (variant && variant.featured_image && mainImage) {
        mainImage.src = variant.featured_image.src
          ? variant.featured_image.src.replace(/(\.[^.\/?]+)(\?.*)?$/, '_800x$1$2')
          : variant.featured_image;
        mainImage.removeAttribute('srcset');
      }

      // Update add to cart button & quantity
      const available = variant && variant.available;
      if (addToCartBtn) {
        addToCartBtn.disabled = !available;
        if (addToCartText) {
          addToCartText.textContent = variant
            ? (available ? strings.add_to_cart : strings.sold_out)
            : strings.unavailable;
        }
      }
      if (quantityInput) {
        quantityInput.disabled = !available;
        if (available && variant && variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny') {
          const max = variant.inventory_quantity > 0 ? variant.inventory_quantity : 1;
          quantityInput.max = max;
          if (parseInt(quantityInput.value, 10) > max) {
            quantityInput.value = max;
          }
        } else {
          quantityInput.removeAttribute('max');
        }
      }
      if (quantityWrapper) {
        quantityWrapper.setAttribute('data-disabled', !available);
      }
    }

    function formatMoney(cents) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      const number = parseInt(cents, 10);
      const value = (number / 100).toFixed(2);
      const noDecimals = Math.round(number / 100);
      return strings.money_format
        .replace(/\{\{\s*amount\s*\}\}/g, value)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(noDecimals).replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
    }

    function onOptionChange() {
      const selectedOptions = getSelectedOptions();
      const variant = findMatchingVariant(selectedOptions);
      updateOptionAvailability();
      updateVariantUI(variant);
    }

    optionInputs.forEach(function(input) {
      input.addEventListener('change', onOptionChange);
    });

    // Quantity buttons
    if (minusBtn && quantityInput) {
      minusBtn.addEventListener('click', function() {
        const val = parseInt(quantityInput.value, 10) || 1;
        if (val > 1) quantityInput.value = val - 1;
      });
    }
    if (plusBtn && quantityInput) {
      plusBtn.addEventListener('click', function() {
        const val = parseInt(quantityInput.value, 10) || 1;
        const max = quantityInput.max ? parseInt(quantityInput.max, 10) : null;
        if (max === null || val < max) quantityInput.value = val + 1;
      });
    }

    // Initial pass to mark crossed-out options and set buy button state correctly
    onOptionChange();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    const section = document.querySelector('.search-section');
    if (!section) return;

    const typeFilter = section.querySelector('[data-type-filter]');
    const viewBtns = section.querySelectorAll('[data-view]');
    const grid = section.querySelector('[data-results-grid]');

    // Type filter change
    if (typeFilter) {
      typeFilter.addEventListener('change', function () {
        const url = new URL(window.location.href);
        const type = this.value;

        if (type === 'all') {
          url.searchParams.delete('type');
        } else {
          url.searchParams.set('type', type);
        }

        window.location.href = url.toString();
      });
    }

    // View toggle
    if (viewBtns.length && grid) {
      viewBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          viewBtns.forEach(function (b) {
            b.classList.remove('active');
          });
          this.classList.add('active');

          if (this.dataset.view === 'list') {
            grid.classList.add('list-view');
          } else {
            grid.classList.remove('list-view');
          }
        });
      });
    }

    // Auto-focus search input on page load if no results
    const searchInput = section.querySelector('.search-section__input');
    if (searchInput && !searchInput.value) {
      searchInput.focus();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
